import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
import './assets/common.less'

import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

Vue.use(dataV)
import store from './store'

import config from './config'

store.dispatch('init', config)

new Vue({
    render: (h) => h(App),
    store: store,
}).$mount("#app");
